import styled from 'styled-components';

export const WrapperDiv = styled.div`
  position: relative;
  width: 100%;
  padding: 0rem 0rem 0rem 2rem;
`;
